import { InteractionType } from 'types/interactiveWidget.types';

export const INTERACTIVE_ELEMENT_WRAPPER_CLASSNAME = 'interactive-element-wrapper';

// The order of the interaction types in this array determines the priority of the interactions when creating the wrapper
// i.e. <Expandable><Tooltip>{children}</Tooltip></Expandable>
export const INTERACTION_TYPE_PRIORITY = [InteractionType.Expandable, InteractionType.Tooltip];
